import { AddCart } from '../actions';
import store from '../store';

const addCart = (e, data)=> {
  // console.log(data)
  store.dispatch(AddCart(data))
}

export const saveToLocal = (name, data) => {
  var data = typeof data === 'string' ? data : JSON.stringify(data);
  window.localStorage.setItem(name, data)
}

export const getFromLocal = (name) => {
  let data = window.localStorage.getItem(name);
  return JSON.parse(data);
}

export default addCart;